const tools = require('../../tools')
const { getProducts, getRelatedLocations } = require('../master-data')
const { getGroup } = require('../read/get')
const { getAllSuppliersBatch } = require('../read/get-all-suppliers-batch')
const { isFacilityUser } = require('../../../user/tools')

// This is only called in above advanceStatus, export is for tests.
exports.createWarehouseSuborders = async function (state, { groupId, dryRun, date, facilityOrdering, supplierId, api = null }) {
  tools.validateParams('createWarehouseSuborders', arguments[1])
  const status = tools.getUserStatus(state.user)
  const {orders, programId} = await getGroup(state, {groupId, withSnapshots: true})

  const isFacility = isFacilityUser(state.user)
  const locationIds = tools.getDestinationIdsOnOrders(orders, groupId)

  let allLocations, suppliers, products

  if (facilityOrdering && isFacility && supplierId) {
    // Fast path: we already know the supplier from listWarehouseStock, so fetch
    // only the supplier + destination docs directly instead of walking the full graph.
    const [fetchedLocations, fetchedProducts] = await Promise.all([
      api.location.getLocationsViaIds([supplierId, ...locationIds]),
      getProducts(state, programId)
    ])
    allLocations = fetchedLocations
    products = fetchedProducts
    const supplierDoc = fetchedLocations.find(loc => loc._id === supplierId)
    suppliers = supplierDoc
      ? [Object.assign({}, supplierDoc, {supplies: new Set(locationIds)})]
      : []
  } else {
    // Standard path: traverse the location graph to resolve suppliers.
    // include facility document if the user location level is sdp
    // facilities can place orders for themselves
    const includeSelf = isFacility && facilityOrdering
    const [fetchedLocations, fetchedProducts] = await Promise.all([
      getRelatedLocations(state, programId, date, includeSelf, api),
      getProducts(state, programId)
    ])
    allLocations = fetchedLocations
    products = fetchedProducts
    suppliers = await getAllSuppliersBatch(state, allLocations, locationIds)
  }

  const updatedSnapshots = tools.createWarehouseSuborders({
    orders,
    suppliers,
    allLocations,
    programId,
    user: state.user,
    products
  })

  if (!dryRun) await state.dal.order.bulkDocs(state, updatedSnapshots)

  const updatedOrders = tools.ordersFromSnapshotUpdates(
    {updatedSnapshots, status, orders, locationId: state.user.location.id}
  )
  return {orders: updatedOrders}
}
